import Component from '@glimmer/component';

import { service } from '@ember/service';
import LinksTo from 'ember-route-state/components/links-to.gjs';
import isStateActive from 'ember-route-state/helpers/is-state-active.js';

import classMod from 'rise-ui/helpers/class-mod.js';

export default class WizardStep extends Component {
  @service router;

  <template>
    {{#let (isStateActive @route) as | isActive |}}
    <li class={{classMod "c-wizard-step" @last "--last" isActive "--active" @complete "--complete"}}
      ...attributes
    >
      <LinksTo @route={{@route}}
        class={{classMod "c-wizard-step__link" @last "--last" isActive "--active" @complete "--complete"}}
      >
        {{~yield~}}
      </LinksTo>
    </li>
    {{/let}}
  </template>
}
